






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import KviCartSelect from '@/components/KviCartSelect.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import {TableHeaders} from '@/interfaces/components-data';
import ModuleApi from "@/pages/ModuleItems/ModuleApi";
import {AxiosResponse} from 'axios';
import {
    CalcIndividualConfig,
    ConfigMap,
    IndividualConfig,
    PromotionIndividualConfig,
    Promotions,
    SaleIndividualConfig,
    Sales,
    SelectBox,
    SelectKviCart,
    SelectMarket,
    StrategyOfPriceOpt,
    TaskInfoCalc,
} from '@/interfaces/global-data';
import {
    CalcIndividualConfigMap,
    CompetitorsPriceFilter,
    GetTaskInfo,
    IndividualConfigCmd,
    InternalCodeAndProductRange,
    KviCartFilters,
    KviCartsSkuFilter,
    KviShoppingCartFilters,
    ProductSegmentIdAndName,
    RegularCompetitorsPricesView,
    Segment,
    Sku,
    SortingField,
    TaskAndFile,
    TaskData,
    TaskInfoFilterType,
    SaleIndividualConfigMap,
    Page,
    PromotionIndividualConfigMap,
    ModuleItemIndividualConfigFieldsToSave,
    IModuleItemSelectedProduct,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import {FormatNumber} from '@/numberFormatter';
import { Formatter } from '@/helpers/formatters';
import {BTabs} from 'bootstrap-vue';
import moment from 'moment';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import {CompetitorsPriceRow} from "@/interfaces/competitors-price-row";
import {compareNumber, sortByFields} from "@/utils/arrayUtils";
import {numberGteZeroState} from "@/utils/utils";
import CollapseCard from '@/components/UI/CollapseCard.vue';
import Card from '@/components/UI/Card.vue';
import {
    IidAndName,
    ILabelAndValue,
    IModuleItemResponseDto,
    IModuleItemsBasicFilters,
    IModuleItemsProduct,
    TModuleType,
    IModuleItemOptionForSelectBox, IModuleItemDeleteProductsFilter,
} from "@/pages/ModuleItems/data";
import {isNull, isNumber} from "lodash";


interface ITableFilterValues {
    groups: number[],
    categories: number[],
    subcategories: number[],
    formats: number[],
    regions: number[],
    clusters: number[],
}

interface ITableFilterOptions {
    groups: ILabelAndValue<number>[],
    categories: ILabelAndValue<number>[],
    subcategories: ILabelAndValue<number>[],
    formats: ILabelAndValue<number>[],
    regions: ILabelAndValue<number>[],
    clusters: ILabelAndValue<number>[],
}

@Component({
    components: {
        KviCartSelect,
        ResultView,
        SideToolbar,
        MultiSelect,
        MarketSelect,
        vSelect,
        LocalData,
        HintsContainer,
        CollapseCard,
        Card,
        CSelect
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD.MM.YYYY');
            }
        },
        formatCompetitorsDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('YYYY-MM-DD');
            }
        },
    },
    methods: {
        isNumber,
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') {
                    return 'table-primary';
                }
                if (item.resultType === 'COMPETITOR') {
                    return 'table-danger';
                }
            }
        },
        formatNumber(number) {
            if (String(number)[0] === '-') {
                return String(number).substring(0, 4);
            } else {
                return String(number).substring(0, 3);
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },
    },
})
export default class ProductsList extends Mixins(LocalData, Toast, Http) {
    @Prop() readonly moduleType!: TModuleType;
    @Prop({required: true}) readonly itemFromList: IModuleItemResponseDto = {} as IModuleItemResponseDto;
    @Prop({required: true}) readonly activeTabKey: string = '' as string;

    correctionFieldValidate(val: any, required: boolean = false): boolean | null {
        return numberGteZeroState(val, required);
    }

    get moduleData(): Sales | Promotions {
        if (this.moduleType === 'promo') {
            return this.$promotions;
        } else {
            return this.$sales;
        }
    }

    set moduleData(data: Sales | Promotions) {
        if (this.moduleType === 'promo') {
            this.$promotions = data as Promotions;
        } else {
            this.$sales = data as Sales;
        }
    }

    get saveModuleItems() {
        if (this.moduleType === 'promo') {
            return this.savePromotions;
        } else {
            return this.saveSales;
        }
    }

    private itemIdForPage: number | 'all' = 'all'
    private itemIdForModal: number | 'all' = 0;

    localSelectKviCart: SelectKviCart = {id: -1, kviCartName: this.$t('shared.productsList.selectKviCartDefault') as string}
    productLineOptions: Array<SelectBox<string>> = [];
    productLineOptionsForFilter: Array<SelectBox<string>> = [];
    selectProductLine: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;

    productRangesArray: InternalCodeAndProductRange[] = [];

    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
    selectKVI: number = this.defaultFilterValue.value;
    selectKVIRecommends: number = this.defaultFilterValue.value;

    filterProductGroupsOptions: Array<SelectBox<number>> = [];
    filterProductCategoriesOptions: Array<SelectBox<number>> = [];
    filterProductSubcategoriesOptions: Array<SelectBox<number>> = [];

    selectFilterProductGroup: number = this.defaultFilterValue.value;
    selectFilterProductCategory: number = this.defaultFilterValue.value;
    selectFilterProductSubcategory: number = this.defaultFilterValue.value;
    selectFilterProductSegment: number = this.defaultFilterValue.value;

    sortingField: SortingField | null = null
    sortByInternalCode: number = -1;
    sortByStoreFormat: number = -1;
    sortByStoreRegion: number = -1;
    sortBySkuName: number = -1;
    sortByCompetitorName: number = -1;
    sortByCompetitorPriority: number = -1;
    sortByLastPrice: number = -1;
    sortByPromoPrice: number = -1;
    sortByCompetitorPrice: number = -1;
    sortByDelta: number = -1;
    sortByKvi: number = -1;
    sortByCtm: number = -1;
    sortByDataIndexCharacteristicOfTheProductIsOne: number = -1;
    sortByDataIndexCharacteristicOfTheProductIsTwo: number = -1;
    sortByCompetitorDate: number = -1;

    kviOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 1, label: 'KVI'},
        {value: 0, label: this.$t('shared.selectBox.notKvi') as string},
    ];

    kviRecommendsOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 0, label: this.$t('shared.selectBox.gk') as string},
        {value: 1, label: this.$t('shared.selectBox.cvk') as string},
    ];

    defaultCtmFilterValue = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectCTM: string = this.defaultCtmFilterValue.value;
    ctmOptions: Array<SelectBox<string>> = [
        this.defaultCtmFilterValue,
        {value: '1', label: 'CTM'},
        {value: '0', label: this.$t('shared.selectBox.notCtm') as string},
    ];

    private api: ModuleApi = new ModuleApi({parent: this});

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
    defaultStringSelectBox: Array<SelectBox<string>> = [{value: 'Все', label: this.$t('shared.selectBox.all') as string}];

    selectSegmentPrice: Segment[] = [];
    segmentPriceOptions: Array<SelectBox<Segment>> = [];
    selectProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    productSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    selectKeyCharacteristicOne: string[] = [];
    selectKeyCharacteristicTwo: string[] = [];
    selectRecipeAttributes: string[] = [];
    selectTreatmentAttributes: number[] = [];
    keyCharacteristicOneOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoOptions: Array<SelectBox<string>> = [];
    recipeAttributesOptions: Array<SelectBox<string>> = [];
    treatmentAttributesOptions: Array<SelectBox<number>> = [];

    selectedCompetitorsCtmFilter: SelectBox<string> = this.defaultCtmFilterValue;

    selectedCompetitorsKviFilter: SelectBox<number> = this.defaultFilterValue;

    selectedMonitoringDateFilter: string[] = [];
    monitoringDateFilterOptions: Array<SelectBox<string>> = [];

    selectedDeltaFilter: string[] = [];
    deltaFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsPriceFilter: string[] = [];
    competitorsPriceFilterOptions: Array<SelectBox<string>> = [];

    selectedLastPriceFilter: string[] = [];
    lastPriceFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsPriorityFilter: string[] = [];
    competitorsPriorityFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsNameFilter: string[] = [];
    competitorsNameFilterOptions: Array<SelectBox<string>> = [];

    selectedSkuNameFilter: string[] = [];
    skuNameFilterOptions: Array<SelectBox<string>> = [];

    selectedKeyCharacteristicOneForCompetitors: string[] = [];
    keyCharacteristicOneForCompetitorsOptions: Array<SelectBox<string>> = [];

    selectedKeyCharacteristicTwoForCompetitors: string[] = [];
    keyCharacteristicTwoForCompetitorsOptions: Array<SelectBox<string>> = [];
    currentMainTab: string = "mainParameters"

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };

    taskInfoPackageKviRecommends: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    errors = [];
    tableKey = 1;
    kviCartComponentKey = 1;
    competitorTableKey = 1;
    skuList: Array<Sku & { storeCluster: IidAndName }> = [];
    skuListAddProductsToCartModal: Sku[] = []
    cartInternalCodes: string[] = [];
    skuListWithAllProducts: Sku[] = [];
    fileResult: string = '';
    taskId: number = 0;
    searchable: boolean = true;

    modalTableFilterValues: ITableFilterValues = {
        groups: [],
        categories: [],
        subcategories: [],
        formats: [],
        regions: [],
        clusters: [],
    };
    modalTableFilterOptions: ITableFilterOptions = {
        groups: [],
        categories: [],
        subcategories: [],
        formats: [],
        regions: [],
        clusters: [],
    };

    addProductsModalTableFields: any[] = [
        {dataIndex: 'selected', title: '✓', scopedSlots: { customRender: 'selected' }, width: 50},
        {dataIndex: 'internalCode', title: this.$t('results.tableHeaders.internalCode') as string, width: 100},
        {dataIndex: 'skuName', title: this.$t('results.tableHeaders.skuName') as string, width: 170, ellipsis: true},
        {
            dataIndex: 'productGroup',
            title: this.$t('results.tableHeaders.productGroup') as string,
            width: 150,
            filterModelKey: 'groups',
            filterOptionsKey: 'groups',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
        },
        {
            dataIndex: 'categoryName',
            title: this.$t('results.tableHeaders.productCategory') as string,
            width: 150,
            filterModelKey: 'categories',
            filterOptionsKey: 'categories',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
        },
        {
            dataIndex: 'subcategory',
            title: this.$t('results.tableHeaders.productSubcategory') as string,
            width: 170,
            filterModelKey: 'subcategories',
            filterOptionsKey: 'subcategories',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
        },
        {
            dataIndex: 'productFormatName',
            title: this.$t('shared.filters.format') as string,
            width: 120,
            filterModelKey: 'formats',
            filterOptionsKey: 'formats',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
        },
        {
            dataIndex: 'productRegionNames',
            title: this.$t('shared.filters.region') as string,
            width: 120,
            filterModelKey: 'regions',
            filterOptionsKey: 'regions',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
        },
        {
            dataIndex: 'productClusterName',
            title: this.$t('shared.filters.cluster') as string,
            width: 120,
            filterModelKey: 'clusters',
            filterOptionsKey: 'clusters',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
        },
        {dataIndex: 'productSegmentName', title: this.$t('results.tableHeaders.productSegment') as string, width: 120, scopedSlots: { filterDropdown: 'segmentFilter', filterIcon: 'segmentFilterIcon' }, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$t('results.tableHeaders.kht1') as string, width: 120, scopedSlots: { filterDropdown: 'kxt1Filter', filterIcon: 'kxt1FilterIcon' }, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$t('results.tableHeaders.kht2') as string, width: 120, scopedSlots: { filterDropdown: 'kxt2Filter', filterIcon: 'kxt2FilterIcon' }, ellipsis: true},
        {dataIndex: 'recipeAttribute', title: this.$t('results.tableHeaders.prc') as string, width: 120, scopedSlots: { filterDropdown: 'prcFilter', filterIcon: 'prcFilterIcon' }, ellipsis: true},
        {dataIndex: 'treatmentAttribute', title: this.$t('results.tableHeaders.pkl') as string, width: 120, scopedSlots: { filterDropdown: 'pklFilter', filterIcon: 'pklFilterIcon' }, ellipsis: true},
        {dataIndex: 'kvi', title: 'KVI', scopedSlots: { customRender: 'kvi', filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, width: 80},
        {dataIndex: 'tagsKvi', title: this.$t('results.tableHeaders.kviTags') as string, scopedSlots: { customRender: 'tagsKvi', filterDropdown: 'tagsKviFilter', filterIcon: 'tagsKviFilterIcon' }, width: 100},
        {dataIndex: 'ctm', title: 'CTM', width: 70, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }, ellipsis: true},
        {dataIndex: 'minMaxRetailPrice', title: this.$t('results.tableHeaders.minMaxRc') as string, width: 150, ellipsis: true, customRender: (value: any, item: any) => `${(item.minRetailPrice) ? this.numberFormatter(item.minRetailPrice) : '-'}/${(item.maxRetailPrice) ? this.numberFormatter(item.maxRetailPrice) : '-'}`},
        {dataIndex: 'productRange', title: this.$t('results.tableHeaders.line') as string, scopedSlots: { customRender: 'productRange', filterDropdown: 'productRangeFilter', filterIcon: 'productRangeFilterIcon' }, width: 130, ellipsis: true},
        {dataIndex: 'lastPrice', title: this.$t('shared.labels.lastPriceShort') as string, width: 130, customRender: (value: any) => value ? this.numberFormatter(value) : '-', ellipsis: true},
        {dataIndex: 'priceSegment', title: this.$t('results.tableHeaders.priceSegment') as string, scopedSlots: { filterDropdown: 'priceSegmentFilter', filterIcon: 'priceSegmentFilterIcon' }, width: 150, ellipsis: true, customRender: (value: any, item: any) => `${(item.priceSegmentMin) ? this.numberFormatter(item.priceSegmentMin) : ''} - ${(item.priceSegmentMax) ? this.numberFormatter(item.priceSegmentMax) : ''}`},
        {dataIndex: 'lastPriceMarginPc', title: this.$t('results.tableHeaders.marginLastPrice') as string, width: 150, ellipsis: true},
        {dataIndex: 'actualProfitability', title: this.$t('shared.labels.actualProfitabilityShort') as string, width: 120, ellipsis: true, customRender: (value: any) => this.numberFormatter(value)},
        {
            dataIndex: 'productVolume',
            title: this.$t('results.tableHeaders.productVolume') as string,
            customRender: (value: any) => this.numberFormatter(value),
            ellipsis: false,
            width: 40,
        },
        {
            dataIndex: 'measurementUnit',
            title: this.$t('results.tableHeaders.measurementUnit') as string,
            ellipsis: false,
            width: 35,
        },
        {
            dataIndex: 'productVerticalLine',
            title: this.$t('results.tableHeaders.productVerticalLine') as string,
            ellipsis: true,
            width: 75,
        },
        {
            dataIndex: 'isVerticalLineBase',
            title: this.$t('results.tableHeaders.isVerticalLineBase') as string,
            customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
            ellipsis: false,
            width: 60,
        },
        {
            dataIndex: 'vlStrategyStr',
            title: this.$t('results.tableHeaders.vlStrategyStr') as string,
            ellipsis: false,
            width: 75,
        },
        {
            dataIndex: 'vlGapPc',
            title: this.$t('results.tableHeaders.vlGapPc') as string,
            customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
            ellipsis: false,
            width: 140,
        },
    ];

    get productsListTableFields(): any[] {
        const allFields = [
            {dataIndex: 'selected', title: '✓', scopedSlots: { customRender: 'selected' }, width: 50},
            {dataIndex: 'internalCode', title: this.$t('results.tableHeaders.internalCode') as string, width: 100},
            {dataIndex: 'skuName', title: this.$t('results.tableHeaders.skuName') as string, width: 170, ellipsis: true},
            {
                dataIndex: 'minPrice',
                title: this.$t('shared.labels.minPriceFirstPeriod') as string,
                width: 70,
                ellipsis: false,
                modelValue: 'minPrice',
                scopedSlots: {
                    customRender: 'individualFieldMinPrice',
                },
            },
            {
                dataIndex: 'maxPrice',
                title: this.$t('shared.labels.maxPriceFirstPeriod') as string,
                width: 70,
                ellipsis: false,
                modelValue: 'maxPrice',
                scopedSlots: {
                    customRender: 'individualFieldMaxPrice',
                },
            },
            {
                module: 'sales',
                dataIndex: 'minSaleDiscount',
                title: this.$t('sales.minSaleDiscount') as string,
                width: 80,
                ellipsis: false,
                modelValue: 'minSaleDiscount',
                scopedSlots: {
                    customRender: 'individualFieldMinSaleDiscount',
                },
            },
            {
                module: 'sales',
                dataIndex: 'maxSaleDiscount',
                // title: this.$t('sales.table.headers.maxDiscount') as string,
                title: this.$t('sales.maxSaleDiscount') as string,
                width: 80,
                ellipsis: false,
                modelValue: 'maxSaleDiscount',
                scopedSlots: {
                    customRender: 'individualFieldMaxSaleDiscount',
                },
            },
            {
                module: 'promo',
                dataIndex: 'minPromotionDiscount',
                title: this.$t('promo.minPromoDiscount') as string,
                width: 80,
                ellipsis: false,
                modelValue: 'minPromotionDiscount',
                scopedSlots: {
                    customRender: 'individualFieldMinPromotionDiscount',
                },
            },
            {
                module: 'promo',
                dataIndex: 'maxPromotionDiscount',
                title: this.$t('promo.maxPromoDiscount') as string,
                width: 80,
                ellipsis: false,
                modelValue: 'maxPromotionDiscount',
                scopedSlots: {
                    customRender: 'individualFieldMaxPromotionDiscount',
                },
            },
            {
                dataIndex: 'minMargin',
                // title: this.$t('sales.table.headers.minProfitability') as string,
                title: this.moduleType === 'promo' ? this.$t('promo.minMargin') as string : this.$t('sales.minMargin') as string,
                width: 80,
                ellipsis: false,
                modelValue: 'minMargin',
                scopedSlots: {
                    customRender: 'individualFieldMinMargin',
                },
            },
            {
                dataIndex: 'remains',
                // title: this.$t('sales.table.headers.balances') as string,
                title: this.moduleType === 'promo' ? this.$t('promo.remains') as string : this.$t('shared.labels.remains') as string,
                // customRender: this.valueUnknown,
                width: 70,
                modelValue: 'remains',
                scopedSlots: {
                    customRender: 'individualFieldRemains',
                },
            },
            {
                dataIndex: 'expiration',
                title: this.$t('shared.labels.shelfLife') as string,
                width: 100,
                scopedSlots: {
                    customRender: 'expirationField',
                },
            },
            {
                dataIndex: 'criticality',
                title: this.moduleType === 'promo' ? this.$t('promo.criticality') as string : this.$t('sales.criticality') as string,
                width: 110,
                scopedSlots: {
                    customRender: 'criticalityField',
                },
            },
            // {dataIndex: 'batchNumber', title: this.$t('shared.competitorsPricesList.batchNumber') as string, width: 80},
            {dataIndex: 'group.name', title: this.$t('results.tableHeaders.productGroup') as string, width: 150, scopedSlots: { filterDropdown: 'groupFilter', filterIcon: 'groupFilterIcon' }, ellipsis: true},
            {dataIndex: 'category.name', title: this.$t('results.tableHeaders.productCategory') as string, width: 150, scopedSlots: { filterDropdown: 'categoryNameFilter', filterIcon: 'categoryNameFilterIcon' }, ellipsis: true},
            {dataIndex: 'subcategory.name', title: this.$t('results.tableHeaders.productSubcategory') as string, width: 170, scopedSlots: { filterDropdown: 'subcategoryFilter', filterIcon: 'subcategoryFilterIcon' }, ellipsis: true},
            {dataIndex: 'storeFormat.name', title: this.$t('shared.filters.format') as string, width: 120, scopedSlots: { filterDropdown: '', filterIcon: '' }, ellipsis: true},
            {dataIndex: 'storeRegion.name', title: this.$t('shared.filters.region') as string, width: 120, scopedSlots: { filterDropdown: '', filterIcon: '' }, ellipsis: true},
            {dataIndex: 'storeCluster.name', title: this.$t('shared.filters.cluster') as string, width: 120, scopedSlots: { filterDropdown: '', filterIcon: '' }, ellipsis: true},
            {dataIndex: 'productSegmentName', title: this.$t('results.tableHeaders.productSegment') as string, width: 120, scopedSlots: { filterDropdown: 'segmentFilter', filterIcon: 'segmentFilterIcon' }, ellipsis: true},
            {dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$t('results.tableHeaders.kht1') as string, width: 120, scopedSlots: { filterDropdown: 'kxt1Filter', filterIcon: 'kxt1FilterIcon' }, ellipsis: true},
            {dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$t('results.tableHeaders.kht2') as string, width: 120, scopedSlots: { filterDropdown: 'kxt2Filter', filterIcon: 'kxt2FilterIcon' }, ellipsis: true},
            {dataIndex: 'recipeAttribute', title: this.$t('results.tableHeaders.prc') as string, width: 120, scopedSlots: { filterDropdown: 'prcFilter', filterIcon: 'prcFilterIcon' }, ellipsis: true},
            {dataIndex: 'treatmentAttribute', title: this.$t('results.tableHeaders.pkl') as string, width: 120, scopedSlots: { filterDropdown: 'pklFilter', filterIcon: 'pklFilterIcon' }, ellipsis: true},
            {dataIndex: 'kvi', title: 'KVI', scopedSlots: { customRender: 'kvi', filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, width: 80},
            {dataIndex: 'tagsKvi', title: this.$t('results.tableHeaders.kviTags') as string, scopedSlots: { customRender: 'tagsKvi', filterDropdown: 'tagsKviFilter', filterIcon: 'tagsKviFilterIcon' }, width: 100},
            {dataIndex: 'ctm', title: 'CTM', width: 70, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }, ellipsis: true},
            {dataIndex: 'productRange', title: this.$t('results.tableHeaders.line') as string, scopedSlots: { customRender: 'productRange', filterDropdown: 'productRangeFilter', filterIcon: 'productRangeFilterIcon' }, width: 130, ellipsis: true},
            {dataIndex: 'lastPrice', title: this.$t('shared.labels.lastPriceShort') as string, width: 130, customRender: (value: any) => !!value || value === 0 ? this.numberFormatter(value) : '-', ellipsis: true},
            {dataIndex: 'priceSegment', title: this.$t('results.tableHeaders.priceSegment') as string, scopedSlots: { filterDropdown: 'priceSegmentFilter', filterIcon: 'priceSegmentFilterIcon' }, width: 150, ellipsis: true, customRender: (value: any, item: any) => `${(item.priceSegmentMin) ? this.numberFormatter(item.priceSegmentMin) : ''} - ${(item.priceSegmentMax) ? this.numberFormatter(item.priceSegmentMax) : ''}`},
            {dataIndex: 'lastPriceMarginPc', title: this.$t('results.tableHeaders.marginLastPrice') as string, width: 150, ellipsis: true},
            {dataIndex: 'actualProfitability', title: this.$t('shared.labels.actualProfitabilityShort') as string, width: 120, ellipsis: true, customRender: (value: any) => this.numberFormatter(value)},
            {dataIndex: 'purchasePriceAvgM', title: this.$t('results.tableHeaders.avgPurchasePrice') as string, scopedSlots: { customRender: 'purchasePriceAvgM' }, width: 100, ellipsis: true, customRender: (value: any) => this.numberFormatter(value)},
            {dataIndex: 'purchasePrice', title: this.$t('results.tableHeaders.promoPurchasePrice') as string, scopedSlots: { customRender: 'purchasePrice' }, width: 120, ellipsis: true},
            {dataIndex: 'coefficentList', title: this.$t('results.tableHeaders.priceOptStrategy') as string, scopedSlots: { customRender: 'coefficentList' }, width: 200, ellipsis: true},
            {dataIndex: 'priceIncreaseLimit', title: this.$t('results.tableHeaders.increaseLimit') as string, scopedSlots: { customRender: 'priceIncreaseLimit' }, width: 150},
            {dataIndex: 'periodPriceIncreaseLimit', title: this.$t('results.tableHeaders.periodPriceIncreaseLimit') as string, scopedSlots: { customRender: 'periodPriceIncreaseLimit' }, width: 160},
            {dataIndex: 'period', title: this.$t('results.tableHeaders.period') as string, scopedSlots: { customRender: 'period' }, width: 80},
            {dataIndex: 'marginalProfit', title: this.$t('results.tableHeaders.minMarginSku') as string, scopedSlots: { customRender: 'marginalProfit' }, width: 150},
            {dataIndex: 'maxMarginalProfit', title: this.$t('results.tableHeaders.maxMarginSku') as string, scopedSlots: { customRender: 'maxMarginalProfit' }, width: 150},
            {dataIndex: 'kviStrategy', title: this.$t('results.tableHeaders.kviStrategy') as string, scopedSlots: { customRender: 'kviStrategy' }, width: 130, ellipsis: true},
            {dataIndex: 'percentageOfCompetitorsPrice', title: this.$t('results.tableHeaders.correction') as string, scopedSlots: { customRender: 'percentageOfCompetitorsPrice' }, width: 100},
            {
                dataIndex: 'productVolume',
                title: this.$t('results.tableHeaders.productVolume') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: false,
                width: 40,
            },
            {
                dataIndex: 'measurementUnit',
                title: this.$t('results.tableHeaders.measurementUnit') as string,
                ellipsis: false,
                width: 35,
            },
            {
                dataIndex: 'productVerticalLine',
                title: this.$t('results.tableHeaders.productVerticalLine') as string,
                ellipsis: true,
                width: 75,
            },
            {
                dataIndex: 'isVerticalLineBase',
                title: this.$t('results.tableHeaders.isVerticalLineBase') as string,
                customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
                ellipsis: false,
                width: 60,
            },
            {
                dataIndex: 'vlStrategyStr',
                title: this.$t('results.tableHeaders.vlStrategyStr') as string,
                ellipsis: false,
                width: 75,
            },
            {
                dataIndex: 'vlGapPc',
                title: this.$t('results.tableHeaders.vlGapPc') as string,
                customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
                ellipsis: false,
                width: 140,
            },
        ];

        const dataIndexesOrder: Record<TModuleType, string[]> = {
            promo: [
                "selected",
                "internalCode",
                "skuName",
                "minPrice",
                "maxPrice",
                "minPromotionDiscount",
                "maxPromotionDiscount",
                "minMargin",
                "remains",
                "productRange",
                "lastPrice",
                "priceSegment",
                "lastPriceMarginPc",
                "actualProfitability",
                "purchasePriceAvgM",
                "purchasePrice",
                "expiration",
                "criticality",
                "group.name",
                "category.name",
                "subcategory.name",
                "storeFormat.name",
                "storeRegion.name",
                "storeCluster.name",
                "productSegmentName",
                "keyCharacteristicOfTheProductIsOne",
                "keyCharacteristicOfTheProductIsTwo",
                "recipeAttribute",
                "treatmentAttribute",
                "kvi",
                "tagsKvi",
                "ctm",
                "coefficentList",
                "priceIncreaseLimit",
                "periodPriceIncreaseLimit",
                "period",
                "marginalProfit",
                "maxMarginalProfit",
                "kviStrategy",
                "percentageOfCompetitorsPrice",
                "productVolume",
                "measurementUnit",
                "productVerticalLine",
                "isVerticalLineBase",
                "vlStrategyStr",
                "vlGapPc",
            ],
            sales: [
                "selected",
                "internalCode",
                "skuName",
                "minPrice",
                "maxPrice",
                "minSaleDiscount",
                "maxSaleDiscount",
                "minMargin",
                "remains",
                "expiration",
                "criticality",
                "group.name",
                "category.name",
                "subcategory.name",
                "storeFormat.name",
                "storeRegion.name",
                "storeCluster.name",
                "productSegmentName",
                "keyCharacteristicOfTheProductIsOne",
                "keyCharacteristicOfTheProductIsTwo",
                "recipeAttribute",
                "treatmentAttribute",
                "kvi",
                "tagsKvi",
                "ctm",
                "productRange",
                "lastPrice",
                "priceSegment",
                "lastPriceMarginPc",
                "actualProfitability",
                "purchasePriceAvgM",
                "purchasePrice",
                "coefficentList",
                "priceIncreaseLimit",
                "periodPriceIncreaseLimit",
                "period",
                "marginalProfit",
                "maxMarginalProfit",
                "kviStrategy",
                "percentageOfCompetitorsPrice",
                "productVolume",
                "measurementUnit",
                "productVerticalLine",
                "isVerticalLineBase",
                "vlStrategyStr",
                "vlGapPc",
            ],
        }

        const orderMap = new Map(dataIndexesOrder[this.moduleType].map((dataIndex, index) => [dataIndex, index]));

        return [...allFields.filter(column => !column.module || column.module === this.moduleType)].sort((a, b) => {
            const indexA = orderMap.get(a.dataIndex);
            const indexB = orderMap.get(b.dataIndex);

            const resIndexA = !!indexA || indexA === 0 ? indexA : Infinity;
            const resIndexB = !!indexB || indexB === 0 ? indexB : Infinity;

            return resIndexA - resIndexB;
        });
    };

    pagination: any = {
        pageSize: 10,
        current: 1,
    };
    paginationInModal: any = {
        pageSize: 10,
        current: 1,
    };

    competitorsTableFields: TableHeaders[] = [
        {key: 'selected', label: ''},
        {key: 'internalCode', label: this.$t('results.tableHeaders.internalCode') as string},
        {key: 'storeFormat', label: this.$t('shared.filters.format') as string},
        {key: 'storeRegion', sortable: true, label: this.$t('shared.filters.region') as string},
        {key: 'skuName', sortable: true, label: this.$t('results.tableHeaders.skuName') as string},
        {key: 'competitorName', sortable: true, label: this.$t('results.tableHeaders.minCompetitorName') as string},
        {key: 'competitorPriority', sortable: true, label: this.$t('shared.competitorsPricesList.competitorPriority') as string},
        {key: 'lastPrice', sortable: true, label: this.$t('shared.competitorsPricesList.ourPrice') as string},
        {key: 'competitorPrice', sortable: true, label: this.$t('shared.competitorsPricesList.competitorPriceFull') as string},
        {key: 'delta', sortable: true, label: this.$t('shared.competitorsPricesList.deviationFull') as string},
        {key: 'kvi', sortable: true, label: 'KVI'},
        {key: 'ctm', sortable: true, label: this.$t('results.tableHeaders.ctm') as string},
        {key: 'keyCharacteristicOfTheProductIsOne', sortable: true, label: this.$t('results.tableHeaders.kht1') as string},
        {key: 'keyCharacteristicOfTheProductIsTwo', sortable: true, label: this.$t('results.tableHeaders.kht2') as string},
        {key: 'competitorDate', sortable: true, label: this.$t('competitorsPricesList.tableHeaders.monitoringDate') as string},
    ];

    competitors: CompetitorsPriceRow[] = [];
    viewCompetitors: CompetitorsPriceRow[] = [];
    skuListLimit: number = 20;
    skuFilter: string = '';
    skuFilterModal: string = '';

    defaultSelectItemOptions: any = [{
        value: 'all',
        label: this.moduleType === 'promo' ? this.$t('promo.allPromos') as string : this.$t('sales.allSales') as string,
    }];

    selectItemOptions: any = [...this.defaultSelectItemOptions];

    isItemsForSelectLoading: boolean = false;

    itemModalSelected: any = {
        groups: [],
        categories: [],
        subcategory: 'all',
        format: 'all',
        regions: [],
        clusters: [],
    };

    itemPageSelected: any = {
        id: 'all',
        name: this.moduleType === 'promo' ? this.$t('promo.allPromos') as string : this.$t('sales.allSales') as string,
        tradingId: null,
        groups: [],
        categories: [],
        subcategory: null,
        format: null,
        regions: [],
        clusters: [],
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minPromotionDiscount: null,
        maxPromotionDiscount: null,
        status: null,
    };

    // private valueUnknown(name: string | null | number): string {
    //     if (name != -1) {
    //         return name
    //     }
    //     return this.$t('shared.labels.undetermined') as string;
    // }

    selectSearch(input: string, option: any) {
        return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
    }

    debounceMinRetailPrice!: () => void;
    serverConfigTimeout: number | null = null;
    loadingConfigs = false;
    marginalErrorText = '';
    globalIndividualMarginalErrorText = '';
    globalIndividualMarginalBlockButton = false;
    globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
    globalIndividualPriceIncreaseLimitBlockButton = false;
    marginalSkuErrorText = '';

    taskData: TaskAndFile | null = null;
    skuListPerPage: number = 20;
    skuListCurrentPage: number = 1;
    skuListTotalRows: number = 0;
    firstDate: number = 0;
    lastDate: number = 0;
    showBookmarks: boolean = true;
    showMainFilters: boolean = true;
    needLoadSkuList = false;
    isActualProfitabilityCalculated: boolean = false;
    isRegularPricesProfitabilityCalculated: boolean = false;
    isDataRangeCalculated: boolean = false;
    isModalTableLoading: boolean = false;
    isPageTableLoading: boolean = false;
    isLoadCompetitorPrices: boolean = false;
    kviSaveProcess: boolean = false;
    useFindKviRecommendsParam: boolean = false;
    tabs: BTabs | null = null;
    showSkuAndSearch: boolean = true;

    private refreshSkuListId = -1;
    private refreshTabPanelSkuListId = -1;

    private skuListWithCalculating: boolean = false;
    private sortBySKU: number = -1;
    private dropDownOpen = false;
// tslint:disable-next-line: ban-types
    private onDropdownClosed: Function | null = null;
    private actualProfitability: number | null = null;
    private regularPricesProfitability: number | null = null;
    private isFiltersChanged = 1;
    private productCodesForAddKvi: string[] = []
    private productCodesForDeleteKvi: string[] = []
    private productCodesForAddCtmPurpose: string[] = []

    private httpExecutor: HttpExecutor = new HttpExecutor();

    private selectedProductsFromPage: IModuleItemSelectedProduct[] = [];
    private selectedProductsFromModal: IModuleItemSelectedProduct[] = [];

    private isAddProductsModalVisible = false;

    numberFormatter = (v: any): string => FormatNumber.format(v);

    mounted() {
        this.tabs = this.$refs.mainTabs as BTabs;

        EventBus.$on('calc', this.onCalcEventReceived);
        EventBus.$on('packageKviRecommends', this.onCalcEventReceived);
        EventBus.$on('tradingNetChanged', this.updateSelectMarket);
        this.$kviCart.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('shared.parametersTab.maxGrossMargin') as string}
    }

    onSearch(){
        this.fetchSkuList();
        this.refreshSkuTableInPanel()
    }

    onSearchModal(){
        this.fetchFullSkuList(1);
        this.refreshSkuTableInModal();
    }

    onSkuTableChange(pagination: any) {
        this.pagination = { ...pagination };
        this.fetchSkuList();
    }

    onSkuTableModalChange(pagination: any) {
        this.paginationInModal = { ...pagination };
        this.fetchFullSkuList();
    }

    isSelectedItemProduct(source: string = 'page', internalCode: string, subcategory: string, productRegionNames: string, productClusterName: string) {
        const selectedProductsVariable = source === 'page' ? 'selectedProductsFromPage' : 'selectedProductsFromModal';

        const index = this[selectedProductsVariable].findIndex((item) => {
            return item.internalCode === internalCode
                && item.subcategory === subcategory
                && item.storeRegion === productRegionNames
                && item.storeCluster === productClusterName;
        });

        return index !== -1;
    }

    setSelectedProducts(source: string = 'page', sku: Sku, selected: boolean) {
        const toSetProductsVariable = source === 'page' ? 'selectedProductsFromPage' : 'selectedProductsFromModal';

        const index = this[toSetProductsVariable].findIndex((item) => {
            return item.internalCode === sku.internalCode
                && item.group === sku.productGroup
                && item.category === sku.categoryName
                && item.subcategory === sku.subcategory
                && item.storeRegion === sku.productRegionNames
                && item.storeCluster === sku.productClusterName;
        });

        if (selected) {
            if (index === -1) {
                const nameAndCodeAndFilterParams: IModuleItemSelectedProduct = {
                    internalCode: sku.internalCode,
                    skuName: sku.skuName,
                    group: sku.productGroup,
                    category: sku.categoryName,
                    subcategory: sku.subcategory,
                    storeRegion: sku.productRegionNames,
                    storeCluster: sku.productClusterName,
                };

            if (toSetProductsVariable === 'selectedProductsFromModal'){
                nameAndCodeAndFilterParams.lastPrice = sku.lastPrice;
            }
                this[toSetProductsVariable].push(nameAndCodeAndFilterParams);
            }
        } else {
            if (index !== -1) {
                this[toSetProductsVariable].splice(index, 1);
            }
        }
    }

    getSelectDefaultValue(internalCode: string, field: string) {
        const period = this.getCalcIndividConfig(this.moduleData.individualCommonParams, internalCode, field as keyof IndividualConfig) as any;
        const value = period && 'value' in period ? period.value : period;
        return value ? (typeof value === 'object' ? value.enum : value) : undefined;
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }
    }

    @Watch('activeTabKey')
    onActiveTabKeyChanged(value: string, oldValue: string) {
        if (value === 'productListSubTab') {
            if (this.selectItemOptions.length < 2) {
                // далее - временно, получение списка всех items легковесных - здесь будет запрос на бэк
                this.fetchItemsForSelect().then(() => {
                    if (this.itemIdForPage !== this.itemFromList.id && !(this.itemFromList.id === null && this.itemIdForPage === 'all')) {
                        this.itemIdForPage = !isNull(this.itemFromList.id) ? this.itemFromList.id : 'all';
                    }
                }).catch(() => {});
            } else {
                if (this.itemIdForPage !== this.itemFromList.id && !(this.itemFromList.id === null && this.itemIdForPage === 'all')) {
                    this.itemIdForPage = !isNull(this.itemFromList.id) ? this.itemFromList.id : 'all';
                }
            }
        }
    }

    @Watch('itemIdForPage')
    async onItemIdForPageChanged(value: number | "all", oldValue: number | "all") {
        this.itemIdForModal = value !== 'all' ? value : 0;

        if (value !== 'all' && !isNull(value)) {
            // далее - временно, получение маски элемента модуля - здесь будет запрос на бэк
            const item = this.selectItemOptions.find((itemObj: any) => itemObj.value === value);

            if (item) {
                this.itemPageSelected = {
                    id: item.value,
                    name: item.label,
                    tradingId: item.tradingId,
                    groups: item.groups,
                    categories: item.categories,
                    subcategory: item.subcategory,
                    format: item.format,
                    regions: item.regions,
                    clusters: item.clusters,
                    minSaleDiscount: item.minSaleDiscount,
                    maxSaleDiscount: item.maxSaleDiscount,
                    minPromotionDiscount: item.minPromotionDiscount,
                    maxPromotionDiscount: item.maxPromotionDiscount,
                    status: item.status,
                }
            } else {
                await this.fetchItemsForSelect();

                const itemAfterFetch = this.selectItemOptions.find((itemObj: any) => itemObj.value === value);

                if (itemAfterFetch) {
                    this.itemPageSelected = {
                        id: itemAfterFetch.value,
                        name: itemAfterFetch.label,
                        tradingId: itemAfterFetch.tradingId,
                        groups: itemAfterFetch.groups,
                        categories: itemAfterFetch.categories,
                        subcategory: itemAfterFetch.subcategory,
                        format: itemAfterFetch.format,
                        regions: itemAfterFetch.regions,
                        clusters: itemAfterFetch.clusters,
                        minSaleDiscount: itemAfterFetch.minSaleDiscount,
                        maxSaleDiscount: itemAfterFetch.maxSaleDiscount,
                        minPromotionDiscount: itemAfterFetch.minPromotionDiscount,
                        maxPromotionDiscount: itemAfterFetch.maxPromotionDiscount,
                        status: itemAfterFetch.status,
                    }
                }
            }
            // конец кода, который должен будет заменён
        } else {
            this.itemPageSelected = {
                id: 'all',
                name: this.moduleType === 'promo' ? this.$t('promo.allPromos') as string : this.$t('sales.allSales') as string,
            }
        }

        this.skuListAddProductsToCartModal = [];
        this.skuFilter = '';

        this.selectedProductsFromPage = [];

        if (value !== 'all' && !isNull(value)) {
            this.fetchSkuList();
        } else {
            this.skuList = [];
            this.pagination.current = 1;
            this.pagination.total = 0;
            this.skuListTotalRows = 0;
        }
    }

    @Watch('itemIdForModal')
    onItemIdForModalChanged(value: string, oldValue: string) {
        if (!!value) {
            // далее - временно, получение маски элемента модуля - здесь будет запрос на бэк
            const item = this.selectItemOptions.find((itemObj: any) => itemObj.value === value);

            if (item) {
                this.itemModalSelected = {
                    groups: item.groups,
                    categories: item.categories,
                    subcategory: item.subcategory,
                    format: item.format,
                    regions: item.regions,
                    clusters: item.clusters,
                }
            }
        } else {
            this.itemModalSelected = {
                groups: [],
                categories: [],
                subcategory: 'all',
                format: 'all',
                regions: [],
                clusters: [],
            }
        }
    }

    @Watch('isAddProductsModalVisible')
    modalVisibleChanged(value: boolean) {
        if (value && !this.skuListAddProductsToCartModal.length) {
            this.loadSkuWithoutCalcModal();
            this.fetchAddProductsModalTableOptions();
        }
    }

    beforeDestroy() {
        EventBus.$off('calc', this.onCalcEventReceived);
        EventBus.$off('packageKviRecommends', this.onCalcEventReceived);
        EventBus.$off('tradingNetChanged', this.updateSelectMarket);

        this.selectedProductsFromPage = [];
        this.selectedProductsFromModal = [];
    }

    resetActualProfitability() {
        this.actualProfitability = null;
    }

    resetRegularPricesProfitability() {
        this.regularPricesProfitability = null;
    }

    resetData(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.categoryOfProduct = null;
                this.$kviCart.subcategory = null;
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.categoryOptions = [];
                this.taskInfo.subcategories = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getCategoryInfo();
                this.getSubcategoryInfo();
                this.getSegmentInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.filterProductGroupsOptions = [];
                this.filterProductCategoriesOptions = [];
                this.filterProductSubcategoriesOptions = [];
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.category:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.subcategory = null;
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.subcategories = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getSubcategoryInfo();
                this.getSegmentInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.filterProductGroupsOptions = [];
                this.filterProductCategoriesOptions = [];
                this.filterProductSubcategoriesOptions = [];
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.subcategory:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getSegmentInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.filterProductGroupsOptions = [];
                this.filterProductCategoriesOptions = [];
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$kviCart.clusterSelected = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.filterProductGroupsOptions = [];
                this.filterProductCategoriesOptions = [];
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.format:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$kviCart.clusterSelected = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.needLoadSkuList = false;
                this.getRegionInfo();
                this.getClusterInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.filterProductGroupsOptions = [];
                this.filterProductCategoriesOptions = [];
                this.filterProductSubcategoriesOptions = [];
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.region:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.clusterSelected = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.needLoadSkuList = false;
                this.getClusterInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.filterProductGroupsOptions = [];
                this.filterProductCategoriesOptions = [];
                this.filterProductSubcategoriesOptions = [];
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.cluster:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.isFiltersChanged = 1;
                this.needLoadSkuList = false;
                this.hideSkuPanel();
                this.filterProductGroupsOptions = [];
                this.filterProductCategoriesOptions = [];
                this.filterProductSubcategoriesOptions = [];
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
        }
        this.keyCharacteristicOneOptions = [];
        this.keyCharacteristicTwoOptions = [];
        this.recipeAttributesOptions = [];
        this.treatmentAttributesOptions = [];
        this.resetActualProfitability();
        this.resetRegularPricesProfitability();
        this.taskId = 0;
        this.fileResult = '';
        this.skuListWithCalculating = false;
    }

    resetCompetitors() {
        this.selectedSkuNameFilter = [];
        this.selectedCompetitorsNameFilter = [];
        this.selectedCompetitorsPriorityFilter = [];
        this.selectedLastPriceFilter = [];
        this.selectedCompetitorsPriceFilter = [];
        this.selectedDeltaFilter = [];
        this.selectedCompetitorsKviFilter = this.defaultFilterValue;
        this.selectedCompetitorsCtmFilter = this.defaultCtmFilterValue;
        this.selectedKeyCharacteristicOneForCompetitors = [];
        this.selectedKeyCharacteristicTwoForCompetitors = [];
        this.selectedMonitoringDateFilter = [];
    }

    resetIndividualConfigs() {
        this.moduleData.individualConfig = {};
        this.moduleData.individualCommonParams = {};
    }

    resetDataRange() {
        this.firstDate = 0;
        this.lastDate = 0;
    }

    resetKVIparams() {
        this.useFindKviRecommendsParam = false;
        this.$kviCart.percentageOfRecommendsKviCount = 10;
        this.$kviCart.useSegmentsPriceInSearchKVIRecParam = false;
        this.$kviCart.saveKviSign = false;
    }

    updateSelectMarket(market: SelectMarket) {
        if (this.$kviCart.selectMarket == null || this.$kviCart.selectMarket.id !== market.id) {
            this.kviCartComponentKey += 1
            this.resetKviShoppingCartData();
            this.$kviCart.selectMarket = market;
            this.skuList = [];
            this.initTask();
            this.saveKviShoppingCart();
            this.tableKey = Math.random();
            this.competitorTableKey = Math.random();
            this.resetDataRange();
            this.hideSkuPanel();
            this.resetActualProfitability();
            this.resetRegularPricesProfitability();
            this.isFiltersChanged = 1;
            this.resetCompetitors();
            this.needLoadSkuList = false;
            this.resetKVIparams();
            this.taskId = 0;
            this.fileResult = '';
            this.productCodesForAddKvi = [];
            this.productCodesForDeleteKvi = [];
            this.segmentPriceOptions = [];
            this.productSegmentIdAndNameOptions = [];
            this.keyCharacteristicOneOptions = [];
            this.filterProductGroupsOptions = [];
            this.filterProductCategoriesOptions = [];
            this.filterProductSubcategoriesOptions = [];
            this.skuListWithCalculating = false;
            this.$kviCart.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('shared.parametersTab.maxGrossMargin') as string}
        }
    }

    showCalcProgress(status: string): boolean {
        return (status === 'WriteToFileComplete'
            || status === 'EmptyData'
            || status === 'ExecutionException'
            || status.includes('Error'));
    }

    clearFilterInUpperPanel() {
        this.skuFilter = '';
        this.fetchSkuList();
        this.refreshSkuTableInPanel();
    }

    clearFilterModal() {
        this.skuFilterModal = '';
        this.fetchFullSkuList(1);
        this.refreshSkuTableInPanel();
    }

    private async fetchItemsForSelect() {
        this.isItemsForSelectLoading = true;

        return await this.api.fetchItems(this.moduleType, {
            tradingId: this.moduleData.selectMarket.id,
            page: 0, // временно, для получения всех (облегчённых) элементов без пагинации нужен отдельный api запрос
            size: 1000, // временно, для получения всех (облегчённых) элементов без пагинации нужен отдельный api запрос
        })
            .then((resp) => {
                if (resp.status === 200) {
                    const array: IModuleItemOptionForSelectBox[] = [];

                    resp.data.content.forEach((e: IModuleItemResponseDto) => {
                        const option: IModuleItemOptionForSelectBox = {
                            value: e.id,
                            label: `#${e.id}: ${e.name}`,
                            groups: e.groups, // временно, после доработок по бэку убрать
                            categories: e.categories, // временно, после доработок по бэку убрать
                            subcategory: e.subcategory, // временно, после доработок по бэку убрать
                            format: e.format, // временно, после доработок по бэку убрать
                            regions: e.regions, // временно, после доработок по бэку убрать
                            clusters: e.clusters, // временно, после доработок по бэку убрать
                            status: e.status, // временно, после доработок по бэку убрать
                        };

                        if (this.moduleType === 'promo') {
                            option.minPromotionDiscount = e.minPromotionDiscount; // временно, после доработок по бэку убрать
                            option.maxPromotionDiscount = e.maxPromotionDiscount; // временно, после доработок по бэку убрать
                        } else {
                            option.minSaleDiscount = e.minSaleDiscount; // временно, после доработок по бэку убрать
                            option.maxSaleDiscount = e.maxSaleDiscount; // временно, после доработок по бэку убрать
                        }

                        array.push(option);
                    });

                    this.selectItemOptions = [...this.defaultSelectItemOptions, ...array];

                    Promise.resolve();
                } else {
                    this.showError(this.$t('shared.productsList.errorLoadItemsList', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);
                }
            })
            .catch((error) => {
                this.showError(this.$t('shared.productsList.errorLoadItemsList', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);
            })
            .finally(() => {
              this.isItemsForSelectLoading = false;
            })
    }

    selectData(): [number[], number[], number[], number[], number[], string | null, Segment[] | null] {
        const selectRegions: number[] = (this.$kviCart.regionSelected.length === 0 || (this.$kviCart.regionSelected.length && this.$kviCart.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$kviCart.regionSelected)!!;
        const selectGroups: number[] = (this.$kviCart.groupsOfProduct.length === 0 || (this.$kviCart.groupsOfProduct.length && this.$kviCart.groupsOfProduct[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$kviCart.groupsOfProduct)!!;
        const selectCategories: number[] = (this.$kviCart.categories.length === 0 || (this.$kviCart.categories.length && this.$kviCart.categories[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$kviCart.categories)!!;
        const selectSubcategories: number[] = (this.$kviCart.subcategories.length === 0 || (this.$kviCart.subcategories.length && this.$kviCart.subcategories[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$kviCart.subcategories)!!;
        const selectSegments: number[] = (this.$kviCart.productSegments.length === 0 || (this.$kviCart.productSegments.length && this.$kviCart.productSegments[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$kviCart.productSegments)!!;
        const ctm: string | null = this.selectCTM === 'all' ? null : this.selectCTM;
        this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
            return item.name !== 'All'
        });

        const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        if(this.selectFilterProductGroup != -1) {
            selectGroups.push(this.selectFilterProductGroup)
        }
        if(this.selectFilterProductCategory != -1) {
            selectCategories.push(this.selectFilterProductCategory)
        }
        if(this.selectFilterProductSubcategory != -1) {
            selectSubcategories.push(this.selectFilterProductSubcategory)
        }
        if(this.selectFilterProductSegment != -1) {
            selectSegments.push(this.selectFilterProductSegment)
        }
        return [selectRegions, selectGroups, selectCategories, selectSubcategories, selectSegments, ctm, priceSegments];
    }

    kviRecommendsSelectData(): [number[], number[], number[], number[]] {
        const selectSeasons: number[] = (this.$packageKviRecommends.seasonSelected.length === 0 || (this.$packageKviRecommends.seasonSelected.length === 1 && this.$packageKviRecommends.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$packageKviRecommends.seasonSelected)!!;
        const selectRegions: number[] = (this.$packageKviRecommends.regionSelected.length === 0 || (this.$packageKviRecommends.regionSelected.length && this.$packageKviRecommends.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$packageKviRecommends.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$packageKviRecommends.buyerSegmentsList.length === 0 || (this.$packageKviRecommends.buyerSegmentsList.length && this.$packageKviRecommends.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$packageKviRecommends.buyerSegmentsList)!!;
        const selectFormats: number[] = (this.$packageKviRecommends.formatSelected.length === 0 || (this.$packageKviRecommends.formatSelected.length && this.$packageKviRecommends.formatSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$packageKviRecommends.formatSelected)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    saveIndividualConfigsInSkuPanel() {
        const saveParams = this.getCommonIndividualFilters();

        this.httpSaveBaseIndividualConfig(saveParams)
            .then((r) => {
                this.showInfo(this.$t('shared.productsList.successSaveIndParams') as string);
                this.refreshSkuTableInPanel();
            })
            .catch((e) => {
                this.showError(this.$t('shared.productsList.errorSaveIndParams') as string);
            })
    }

    initTask() {
        if (this.$kviCart.selectMarket.id === -1) {
            return;
        }
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);

        this.$kviCart.groupOfProduct = null;
        this.$kviCart.categoryOfProduct = null;
        this.$kviCart.subcategory = null;
        this.$kviCart.segment = null;
        this.taskInfo.storeFormatOptions = [];
        this.taskInfo.groupsOfProduct = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.psegemnts = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.clusterOptions = [];
        const self = this;
        self.getFormatInfo();
        self.getRegionInfo();
        self.getGroupInfo();
        self.getCategoryInfo();
        self.getSubcategoryInfo();
        self.getSegmentInfo();
        self.getClusterInfo();
    }

    getRegionInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.updateRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getKviRecommendsRegionInfo() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.updateKviRecommendsRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfoPackageKviRecommends.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getSegmentPriceInfo() {
        const filter = this.getSkuFilter()
        this.httpGetMinMaxPriceSegmentForKviCarts(filter)
            .then((data) => {
                const filterData = data.data;
                this.segmentPriceOptions = filterData.map((i) => {
                    return {value: i, label: i.name}
                });
            })
            .catch((e) => {
            })
    }

    getProductSegmentIdAndName() {
        if (this.$kviCart.selectMarket.id === -1) {
            return;
        }
        const filter = this.getSkuFilter()
        filter.tagType = TaskInfoFilterType.p_segemnt
        filter.categoryFilterInSkuList = this.selectFilterProductCategory
        filter.subcategoryFilterInSkuList = this.selectFilterProductSubcategory
        filter.storeFormat = null
        const subcategoryFilter = filter.categoryFilterInSkuList === -1 ? [] : [filter.subcategoryFilterInSkuList];
        this.httpGetProductSegmentIdAndName( {...filter, subcategories: subcategoryFilter})
            .then((data) => {
                const filterData = data.data;
                this.productSegmentIdAndNameOptions = filterData.map((i) => {
                    return {value: i, label: i.segmentName}
                });
            })
            .catch((e) => {
            })
    }

    getSkuKeysAndAttributes() {
        if (this.$kviCart.selectMarket.id === -1) {
            return;
        }
        const filter = this.getSkuFilter()
        filter.groupsOfProduct = []
        filter.categories = []
        filter.subcategories = []
        filter.priceSegments = []
        filter.storeFormat = null
        filter.storeCluster = null
        filter.categoryFilterInSkuList = this.selectFilterProductCategory
        filter.subcategoryFilterInSkuList = this.selectFilterProductSubcategory
        filter.segmentFilterInSkuList = this.selectFilterProductSegment
        const subcategoryFilter = filter.categoryFilterInSkuList === -1 ? [] : [filter.subcategoryFilterInSkuList];
        const segmentsFilter = filter.segmentFilterInSkuList === -1 ? [] : [filter.segmentFilterInSkuList];
        this.httpGetSkuKeysAndAttributes({...filter, subcategories: subcategoryFilter, productSegments: segmentsFilter})
            .then((result) => {
                this.keyCharacteristicOneOptions = result.data.keyProducts1.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicTwoOptions = result.data.keyProducts2.map((item) => {
                    return {value: item, label: item};
                });
                this.recipeAttributesOptions = result.data.recipeAttributes.map((item) => {
                    return {value: item, label: item};
                });
                this.treatmentAttributesOptions = result.data.treatmentAttributes.map((item) => {
                    return {value: item, label: item.toString()};
                });
            })
            .catch((e) => {
            })
    }

    getFormatInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.formatSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });

                this.taskInfo.storeFormatOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfo.storeFormatOptions];
            })
            .catch((e) => {
            });
    }

    getGroupInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;

                this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }


    getCategoryInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;

                this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getSubcategoryInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;

                this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getSegmentInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
            .then((data) => {
                const filterData = data.data;

                this.taskInfo.psegemnts = filterData.psegments.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getKviRecommendsFormatInfo() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.kviRecommendsFormatSelectedRef as any).toggleLoading(false);
                }, 500);
                this.taskInfoPackageKviRecommends.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });

            })
            .catch((e) => {
            });
    }

    getKviRecommendsBuyerSegment() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.buyer))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.updateKviRecommendsBuyerSegmentsRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoPackageKviRecommends.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                    return {value: i.id, label: i.name};
                });

            })
            .catch((e) => {
            });
    }

    getClusterInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfo.clusterOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfo.clusterOptions];
            })
            .catch((e) => {
            });
    }

    prepareIndividualConfig(config: IndividualConfig): CalcIndividualConfig {
        const prepared: CalcIndividualConfig = {};

        if ('kviStrategy' in config && typeof config.kviStrategy !== 'undefined' && config.kviStrategy !== null) {
            prepared.kviStrategy = config.kviStrategy.value
        }

        if ('marginalProfit' in config && typeof config.marginalProfit !== 'undefined' && config.marginalProfit !== null) {
            prepared.marginalProfit = config.marginalProfit;
        }

        if ('priceChangeLimit' in config && typeof config.priceChangeLimit !== 'undefined' && config.priceChangeLimit !== null) {
            prepared.priceChangeLimit = config.priceChangeLimit;
        }

        if ('selectCoefficent' in config && typeof config.selectCoefficent !== 'undefined' && config.selectCoefficent !== null) {
            const coef = config.selectCoefficent;
            prepared.coefficientK1 = coef.value.k1;
            prepared.coefficientK2 = coef.value.k2;
            prepared.priceOpt = coef.value.enum;
        }

        if ('priceIncreaseLimit' in config && typeof config.priceIncreaseLimit !== 'undefined' && config.priceIncreaseLimit !== null) {
            prepared.priceIncreaseLimit = config.priceIncreaseLimit;
        }

        if ('competitorsPricesParams' in config && typeof config.competitorsPricesParams !== 'undefined' && config.competitorsPricesParams !== null) {
            prepared.competitorsPricesParams = config.competitorsPricesParams;
        }

        if ('percentageOfCompetitorsPrice' in config) {
            prepared.percentageOfCompetitorsPrice = config.percentageOfCompetitorsPrice;
        }

        if ('periodPriceIncreaseLimit' in config && typeof config.periodPriceIncreaseLimit !== 'undefined' && config.periodPriceIncreaseLimit !== null) {
            prepared.periodPriceIncreaseLimit = config.periodPriceIncreaseLimit;
        }

        if ('period' in config && typeof config.period !== 'undefined' && config.period !== null) {
            prepared.period = config.period.value;
        }

        return prepared;
    }

    hideSkuPanel() {
        this.clearFilters();
    }

    loadSkuWithoutCalc() {
        this.skuListWithCalculating = false;
        this.needLoadSkuList = true;
        this.fetchSkuList();
    }

    loadSkuWithoutCalcModal() {
        this.skuListWithCalculating = false;
        this.needLoadSkuList = true;
        this.fetchFullSkuList();
    }

    loadSkuWithCalcInPanel() {
        this.skuListWithCalculating = true;
        this.fetchSkuList();
        this.refreshSkuTableInPanel();
    }

    fetchAddProductsModalTableOptions() {
        this.modalTableFilterOptions = {
            groups: [],
            categories: [],
            subcategories: [],
            formats: [],
            regions: [],
            clusters: [],
        };
        this.modalTableFilterValues = {
            groups: [],
            categories: [],
            subcategories: [],
            formats: [],
            regions: [],
            clusters: [],
        };

        const filters: IModuleItemsBasicFilters = {
            tradingId: this.moduleData.selectMarket.id,
            groupsOfProduct: this.itemModalSelected.groups.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            categories: this.itemModalSelected.categories.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            subcategories: !!this.itemModalSelected.subcategory && this.itemModalSelected.subcategory !== 'all' ? [this.itemModalSelected.subcategory.id] : [],
            storeFormats: [this.itemModalSelected.format.id],
            storeRegionValues: this.itemModalSelected.regions.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            storeClusters: this.itemModalSelected.clusters.map((el: IidAndName) => el.id).realValuesOrEmpty(),
        };

        this.httpFetchAssortmentFilterOptions(filters, { isSales: this.moduleType === 'sales' })
            .then(response => {
                    this.modalTableFilterOptions.groups = response.data.groups.map(el => ({ value: el.id, label: el.name }));
                    this.modalTableFilterOptions.categories = response.data.categories.map(el => ({ value: el.id, label: el.name }));
                    this.modalTableFilterOptions.subcategories = response.data.subcategories.map(el => ({ value: el.id, label: el.name }));
                    this.modalTableFilterOptions.formats = response.data.storeFormats.map(el => ({ value: el.id, label: el.name }));
                    this.modalTableFilterOptions.regions = response.data.storeRegions.map(el => ({ value: el.id, label: el.name }));
                    this.modalTableFilterOptions.clusters = response.data.storeClusters.map(el => ({ value: el.id, label: el.name }));
                },
            );
    }

    fetchFullSkuList(currentPage?: number) {
        if (currentPage) {
            this.paginationInModal.current = currentPage;
        }

        const filter = {
            tradingId: this.moduleData.selectMarket.id,
            groupsOfProduct: this.modalTableFilterValues.groups.length ? this.modalTableFilterValues.groups : this.itemModalSelected.groups.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            categories: this.modalTableFilterValues.categories.length ? this.modalTableFilterValues.categories : this.itemModalSelected.categories.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            subcategories: this.modalTableFilterValues.subcategories.length ? this.modalTableFilterValues.subcategories : (!!this.itemModalSelected.subcategory && this.itemModalSelected.subcategory !== 'all' ? [this.itemModalSelected.subcategory.id] : []),
            storeFormats: this.modalTableFilterValues.formats.length ? this.modalTableFilterValues.formats : [this.itemModalSelected.format.id],
            storeRegionValues: this.modalTableFilterValues.regions.length ? this.modalTableFilterValues.regions : this.itemModalSelected.regions.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            storeClusters: this.modalTableFilterValues.clusters.length ? this.modalTableFilterValues.clusters : this.itemModalSelected.clusters.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            kvi: 2,
            kviCartIdFilter: -1,
            needCalculateSku: false,
            skuFilter: this.skuFilterModal,
        };

        const offset = (this.paginationInModal.current - 1) * this.paginationInModal.pageSize;

        this.isModalTableLoading = true;

        this.httpGetKviCartSkuList(filter as any, this.paginationInModal.pageSize, offset, this.moduleType === 'sales')
            .then((r: AxiosResponse<Page<Sku[]>>) => {
                    this.skuListAddProductsToCartModal = Object.assign([], r.data.content);

                    this.cartInternalCodes = this.skuListAddProductsToCartModal.map((value) => value.internalCode);
                    const pagination = { ...this.paginationInModal };
                    pagination.total = r.data.totalElements;
                    this.paginationInModal = pagination;
                    this.skuListTotalRows = r.data.totalElements;
                    this.isModalTableLoading = false;
                    this.isFiltersChanged = 0;
                },
            )
            .catch(() => {
                this.isModalTableLoading = false;
                this.isFiltersChanged = 0;
                this.skuListAddProductsToCartModal = [];
            });
    }

    fetchSkuList() {
        const filter: any = {
            tradingId: this.moduleData.selectMarket.id,
            groupsOfProduct: this.itemPageSelected.groups.map((el: IidAndName) => el.id),
            categories: this.itemPageSelected.categories.map((el: IidAndName) => el.id),
            subcategories: this.itemPageSelected.id !== 'all' && !!this.itemPageSelected.subcategory ? [this.itemPageSelected.subcategory.id] : [],
            storeFormat: this.itemPageSelected.id !== 'all' ? this.itemPageSelected.format.id : null,
            storeRegionValues: this.itemPageSelected.regions.map((el: IidAndName) => el.id),
            storeClusters: this.itemPageSelected.clusters.map((el: IidAndName) => el.id),
            kvi: 2,
            kviCartIdFilter: -1,
            needCalculateSku: this.skuListWithCalculating,
            calculationDay: this.moduleData.calculationDay,
            skuFilter: this.skuFilter,
        };

        if (this.moduleType === 'promo') {
            filter.promotionIdFilter = this.itemPageSelected.id !== 'all' ? this.itemPageSelected.id : -1;
        } else {
            filter.saleIdFilter = this.itemPageSelected.id !== 'all' ? this.itemPageSelected.id : -1;
        }

        const offset = (this.pagination.current - 1) * this.pagination.pageSize;

        this.isPageTableLoading = true;

        this.httpGetModuleItemSkuList(this.moduleType, filter as any, this.pagination.pageSize, offset)
            .then((r) => {
                    this.skuList = r.data.content.map(el => ({
                        ...el,
                        subcategory: el.subcategory || '',
                        storeCluster: el.storeCluster || '',
                    }));

                    this.moduleData.individualConfig = {};
                    this.cartInternalCodes = this.skuList.map((value) => value.internalCode);

                    const pagination = { ...this.pagination };
                    pagination.total = r.data.totalElements;
                    this.pagination = pagination;

                    this.skuListTotalRows = r.data.totalElements;
                    this.isPageTableLoading = false;
                    this.isFiltersChanged = 0;
                },
            )
            .catch((e) => {
                this.isPageTableLoading = false;
                this.isFiltersChanged = 0;
                this.skuList = [];
            });
    }

    resetAllSortingFields() {
        this.sortByInternalCode = -1
        this.sortByStoreFormat = -1;
        this.sortByStoreRegion = -1;
        this.sortBySkuName = -1;
        this.sortByCompetitorName = -1;
        this.sortByCompetitorPriority = -1;
        this.sortByLastPrice = -1;
        this.sortByPromoPrice = -1;
        this.sortByCompetitorPrice = -1;
        this.sortByDelta = -1;
        this.sortByKvi = -1;
        this.sortByDataIndexCharacteristicOfTheProductIsOne = -1;
        this.sortByDataIndexCharacteristicOfTheProductIsTwo = -1;
        this.sortByCompetitorDate = -1;
    }

    sortSkuListBySKUInTablePanel() {
        if (this.sortBySKU === -1 || this.sortBySKU === 1) {
            this.sortBySKU = 0;
        } else {
            this.sortBySKU = 1;
        }
        this.refreshSkuTableInPanel();
    }

    isPriceCategoryRecommends(sku: Sku): boolean {
        return sku.priceCategoryRecommendation;
    }

    isCartGeneratorRecommends(sku: Sku): boolean {
        return sku.cartGeneratorRecommendation;
    }

    isSelectedKvi(sku: Sku): boolean {
        return sku.kvi === 1;
    }

    setSelectedKvi(sku: Sku, selected: boolean) {
        if (selected) {
            if (sku.kvi !== 1) {
                this.productCodesForAddKvi.push(sku.internalCode);
            }
            const index = this.productCodesForDeleteKvi.findIndex((item) => {
                return item === sku.internalCode
            });
            if (index !== -1) {
                this.productCodesForDeleteKvi.splice(index, 1);
            }
        } else {
            if (sku.kvi === 1) {
                this.productCodesForDeleteKvi.push(sku.internalCode);
            }
            const index = this.productCodesForAddKvi.findIndex((item) => {
                return item === sku.internalCode
            });
            if (index !== -1) {
                this.productCodesForAddKvi.splice(index, 1);
            }
        }
    }

    getProductRange(productLine: string): string {
        const index = this.productLineOptions.findIndex((item) => {
            return item.value === productLine
        });

        if (index !== -1) {
            return this.productLineOptions[index].value
        } else {
            return ''
        }
    }

    inputOrDeleteProductRange(row: Sku, value: string) {
        const index = this.productRangesArray.findIndex((item) => {
            return item.internalCode === row.internalCode
        });

        const rangeAndCode: InternalCodeAndProductRange = {
            internalCode: row.internalCode,
            productRange: value,
        };

        if (index === -1) {
            this.productRangesArray.push(rangeAndCode)
        } else {
            this.productRangesArray.splice(index, 1)
            this.productRangesArray.push(rangeAndCode)
        }
    }

    saveKviParamsForSkuInPanel() {
        const filters = this.getFullCommonFilter();
        this.kviSaveProcess = true;
        this.httpSaveOrDeleteKviParam(filters)
            .then((r) => {
                this.kviSaveProcess = false;
                this.showInfo(this.$t('shared.messages.savingKvi') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.refreshSkuTableInPanel();
            })
            .catch((e) => {
                this.kviSaveProcess = false;
                this.showError(this.$t('shared.productsList.errorSaveIndParams') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
            });
    }

    clearFilters() {
        this.sortBySKU = -1;
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
        this.selectSegmentPrice = [];
        this.selectProductSegmentIdAndName = [];
        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectProductLine = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
        this.selectFilterProductGroup = this.defaultFilterValue.value;
        this.selectFilterProductCategory = this.defaultFilterValue.value;
        this.selectFilterProductSubcategory = this.defaultFilterValue.value;
        this.refreshSkuList()
    }

    calcButtonState(): boolean {
        if (this.$kviCart.selectMarket != null) {
            const state = this.paramsSum && this.paramsSumXYZ && this.calculationDepthValidate
                && this.calculationDayValidate && this.priceIncreaseLimitValidate && this.competitorsPricesValidate
                && this.marginalProfitValidate && this.highElasticityCheck && this.minProfitKVIValidate && this.competitorsMinProfitValidate
                && this.periodPriceIncreaseLimitValidate && this.priceChangeLimitValidate && this.competitorPriceControlParameterPcValidate && this.marginalProfitDeclinePcValidate;
            return !state;

        }
        return true;
    }

    applyFilterByKey(searchValues: string[], field: keyof CompetitorsPriceRow, sourceValues: CompetitorsPriceRow[] = this.viewCompetitors) {
        return this.filterIfNotEmpty(sourceValues, searchValues, (v, s) => `${v[field]}` == s)
    }

    applyFilter(searchValues: string[],  equals: (v: CompetitorsPriceRow, s: string) => boolean) {
        return this.filterIfNotEmpty(this.viewCompetitors, searchValues, equals)
    }

    filterIfNotEmpty<V, S>(values: V[], searchValues: S[], equals: (v: V, s: S) => boolean) {
        return searchValues.length ? values.filter((value) => {
            return searchValues.filter((searchValue) => equals(value, searchValue)).length
        }) : values;
    }

    toRow(competitor: RegularCompetitorsPricesView): CompetitorsPriceRow {
        const delta = this.computedDelta({lastPrice: competitor.lastPrice, competitorPrice: competitor.competitorPrice});
        return {
            ...competitor,
            competitorDate: new Date(competitor.priceDate),
            ctm: competitor.ctm == null ? this.$t('shared.labels.no') as string : competitor.ctm,
            delta,
        }
    }

    setSelectAll(exclude: 'SkuName' | 'CompetitorsName' | 'CompetitorPriority' | 'Delta' | 'LastPrice' | 'CompetitorPrices' | 'Kxt1' | 'Kxt2' | 'MonitorDates' | null): void {
        exclude != 'SkuName' && this.setSelectSkuName(this.viewCompetitors);
        exclude != 'CompetitorsName' && this.setSelectCompetitorsName(this.viewCompetitors);
        exclude != 'CompetitorPriority' && this.setSelectCompetitorsPriority(this.viewCompetitors);
        exclude != 'LastPrice' && this.setSelectLastPrice(this.viewCompetitors);
        exclude != 'CompetitorPrices'&& this.setSelectCompetitorsPrice(this.viewCompetitors);
        exclude != 'Delta' && this.setSelectDelta(this.viewCompetitors);
        exclude != 'MonitorDates' && this.setSelectMonitorDate(this.viewCompetitors);
        exclude != 'Kxt1'&& this.setSelectCompetitorsKxtOne(this.viewCompetitors);
        exclude != 'Kxt2' && this.setSelectCompetitorsKxtTwo(this.viewCompetitors);
    }

    setSelectSkuName(response: CompetitorsPriceRow[]) {
        const skuNameOptions = response.map((value) => value.skuName)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.skuNameFilterOptions = Array.from(new Set(skuNameOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsName(response: CompetitorsPriceRow[]) {
        const competitorsNameOptions = response.map((value) => value.competitorName)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.competitorsNameFilterOptions = Array.from(new Set(competitorsNameOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsPriority(response: CompetitorsPriceRow[]) {
        const competitorsPriorityOptions = response.map((value) => value.competitorPriority).sort(compareNumber)
        this.competitorsPriorityFilterOptions = Array.from(new Set(competitorsPriorityOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectLastPrice(response: CompetitorsPriceRow[]) {
        const lastPriceOptions = response.map((value) => value.lastPrice).sort(compareNumber)
        this.lastPriceFilterOptions = Array.from(new Set(lastPriceOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectCompetitorsPrice(response: CompetitorsPriceRow[]) {
        const competitorsPriceOptions = response.map((value) => value.competitorPrice).sort(compareNumber)
        this.competitorsPriceFilterOptions = Array.from(new Set(competitorsPriceOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectDelta(response: CompetitorsPriceRow[]) {
        const deltaOptions = response.map((value) => this.computedDelta(value))
            .sort(compareNumber)
            .map((delta) => delta ? delta.toFixed(2) : '0')
        this.deltaFilterOptions = Array.from(new Set(deltaOptions)).map((deltaOption) => ({
            value: deltaOption,
            label: deltaOption,
        }))
    }

    setSelectCompetitorsKxtOne(response: CompetitorsPriceRow[]) {
        const competitorsKxtOneOptions = response.map((value) => value.keyCharacteristicOfTheProductIsOne)
            .filter((it) => it !== null)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.keyCharacteristicOneForCompetitorsOptions = Array.from(new Set(competitorsKxtOneOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsKxtTwo(response: CompetitorsPriceRow[]) {
        const competitorsKxtTwoOptions = response.map((value) => value.keyCharacteristicOfTheProductIsTwo)
            .filter((it) => it !== null)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.keyCharacteristicTwoForCompetitorsOptions = Array.from(new Set(competitorsKxtTwoOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectMonitorDate(response: CompetitorsPriceRow[]) {
        const formattedDates = response.map((value) => new Date(value.competitorDate))
            .sort((a: Date, b: Date) => (a.getTime() - b.getTime()))
            .map((value) => value.toLocaleDateString())
        this.monitoringDateFilterOptions = Array.from(new Set(formattedDates)).map((formattedDate) => ({
            value: formattedDate,
            label: formattedDate,
        }))
    }

    computedDelta = (item: { lastPrice: number,  competitorPrice: number}): number => {
        return ((item.lastPrice / item.competitorPrice - 1) * 100);
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null
            }
        }
    }

    addSelectedProductsToItem() {
        const filter: any = {
            tradingId: this.moduleData.selectMarket.id,
            groups: this.itemPageSelected.groups.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            categories: this.itemPageSelected.categories.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            subcategories: !!this.itemPageSelected.subcategory ? [this.itemPageSelected.subcategory.id] : null,
            storeFormat: this.itemPageSelected.format.id,
            storeRegions: this.itemPageSelected.regions.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            storeClusters: this.itemPageSelected.clusters.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            products: this.selectedProductsFromModal,
        };

        if (this.moduleType === 'promo') {
            filter.promotionId = this.itemPageSelected.id;
        } else {
            filter.saleId = this.itemPageSelected.id;
        }

        this.httpAddSelectedProductToModuleItem(this.moduleType, filter)
            .then(() => {
                this.showInfo(this.$t('shared.productsList.successAddToItem', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameAcc') as string : this.$t('sales.typeNameAcc') as string }) as string);

                this.selectedProductsFromModal = [];
                this.fetchSkuList();
                this.refreshSkuList();
                this.refreshSkuTableInPanel();
            })
            .catch((e) => {
                this.showError(e.response.data, 5);
            });
    }

    handleDeleteSelectedProducts() {
        const filter: IModuleItemDeleteProductsFilter = {
            tradingId: this.moduleData.selectMarket.id,
            internalCodesAndSkuNames: this.selectedProductsFromPage,
        };

        if (this.moduleType === 'promo') {
            filter.promotionIdFilter = this.itemPageSelected.id;
        } else {
            filter.saleIdFilter = this.itemPageSelected.id;
        }

        this.httpDeleteSelectedProductsFromModuleItem(this.moduleType, filter)
            .then(() => {
                this.showInfo(this.$t('shared.productsList.successDeleteFromItem', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);

                this.selectedProductsFromPage = [];
                this.fetchSkuList();
                this.refreshSkuTableInPanel();
            })
            .catch(() => {
                this.showError(this.$t('shared.productsList.errorDeleteFromItem', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);
            });
    }

    setCalcIndividConfig(config: ConfigMap<IndividualConfig>, sku: string, property: keyof IndividualConfig, value: number | SelectBox<any> | string) {
        if (!(sku in config)) {
            config[sku] = {};
        }
        if ((typeof value === 'number' && Number.isNaN(value)) || (typeof value === 'string' && value.trim() === '')) {
            config[sku][property] = null;
        } else {
            config[sku][property] = value;
        }
    }

    setModuleItemIndividConfig(config: ConfigMap<SaleIndividualConfig | PromotionIndividualConfig>, sku: string, property: keyof (SaleIndividualConfig | PromotionIndividualConfig), value: number | SelectBox<any> | string) {
        if (!(sku in config)) {
            this.$set(config, sku, {});
        }

        if (typeof value === 'number' && Number.isNaN(value)) {
            this.$set(config[sku], property, null);
        } else {
            this.$set(config[sku], property, value);
        }
    }

    getModuleItemIndividConfig(config: ConfigMap<SaleIndividualConfig | PromotionIndividualConfig>, key: string, property: keyof (SaleIndividualConfig | PromotionIndividualConfig)): number | SelectBox<any> | string | null | boolean | any[] {
        if (key in config) {
            return config[key][property]!;
        }

        return null;
    }

    getSelectIndividConfig(internalCode: any, key: any) {
        const value = this.getCalcIndividConfig(this.moduleData.individualCommonParams, internalCode, key) as {label: string, value: any}
        if(value && value.value){
            return value.value.enum
        }
        return value
    }

    private refreshSkuList() {
        const oldRefreshId = this.refreshSkuListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshSkuListId === timeoutId) {
                this.skuListCurrentPage = 1;
                const skuTableInPanel = this.$refs.skuTableInPanel as any;
                if (typeof skuTableInPanel !== 'undefined') {
                    skuTableInPanel.$forceUpdate();
                }
                this.refreshSkuListId = -1;
            }
        }, 250);
        this.refreshSkuListId = timeoutId;
        this.isFiltersChanged = 1;
    }

    private refreshSkuTableInPanel() {
        const oldRefreshId = this.refreshTabPanelSkuListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshTabPanelSkuListId === timeoutId) {
                this.pagination.current = 1;
                const skuTableInPanel = this.$refs.skuTableInPanel as any;
                if (typeof skuTableInPanel !== 'undefined') {
                    skuTableInPanel.$forceUpdate();
                }
                this.refreshTabPanelSkuListId = -1;
            }
        }, 250);
        this.refreshTabPanelSkuListId = timeoutId;
        this.isFiltersChanged = 1;
    }

    private refreshSkuTableInModal() {
        const skuTableInModal = this.$refs.skuTableInModal as any;
        if (typeof skuTableInModal !== 'undefined') {
            skuTableInModal.$forceUpdate();
        }
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        const [selectRegions, selectGroups, selectCategories, selectSubcategories, selectSegments] = this.selectData();
        return {
            type: taskType,
            tradingId: this.$kviCart.selectMarket.id,
            storeFormat: this.$kviCart.formatSelected == null || this.$kviCart.formatSelected <= 0 ? null : [this.$kviCart.formatSelected],
            storeCluster: this.$kviCart.clusterSelected == null ? null : this.$kviCart.clusterSelected,
            groups: selectGroups,
            categories: selectCategories,
            subcategories: selectSubcategories,
            subcategory: this.$kviCart.subcategory == null || this.$kviCart.subcategory <= 0 ? null : [this.$kviCart.subcategory],
            productSegments: selectSegments,
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getKviRecommendsTaskInfo(filterType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions, , selectFormats] = this.kviRecommendsSelectData();
        return {
            type: filterType,
            tradingId: this.$packageKviRecommends.selectMarket.id,
            categories: LocalData.filterNumberArrays(this.$packageKviRecommends.categoriesOfProduct),
            groups: LocalData.filterNumberArrays(this.$packageKviRecommends.groupsOfProduct),
            subcategory: LocalData.filterNumberArrays(this.$packageKviRecommends.subcategories, true),
            segments: null,
            storeFormat: selectFormats,
            storeCluster: this.$packageKviRecommends.clusterSelected,
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getFullCommonFilter(): KviShoppingCartFilters {
        const [selectRegions, selectGroups, selectCategories, selectSubcategories, selectSegments] = this.selectData();
        const allCheck = this.$kviCart.allCheck;
        const discountPrice = this.$kviCart.discountPrice;
        const pennies = this.$kviCart.pennies;
        const countAtLastPurchasePrice = this.$kviCart.countAtLastPurchasePrice;
        const countAtFuturePurchasePrice = this.$kviCart.countAtFuturePurchasePrice;
        const allNewPricesWithoutPennies = this.$kviCart.allNewPricesWithoutPennies;
        const allClaster = this.$kviCart.allClaster;
        const xyzChecked = this.$kviCart.xyzChecked;
        const uvwChecked = this.$kviCart.uvwChecked;
        const individualConfigsObj = Object.create(null);
        // tslint:disable-next-line: forin
        for (const key in this.moduleData.individualCommonParams) {
            const value = this.moduleData.individualCommonParams[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }
        return {
            allCheck,
            discountPrise: discountPrice,
            pennies,
            countAtLastPurchasePrice,
            countAtFuturePurchasePrice,
            allNewPricesWithoutPennies,
            xyzChecked,
            uvwChecked,
            allClaster,
            coefficientK1: this.$kviCart.selectCoefficent.value.k1,
            coefficientK2: this.$kviCart.selectCoefficent.value.k2,
            category: null,
            storeCluster: this.$kviCart.clusterSelected,
            seasonValues: [],
            buyerSegments: [],
            spreadUVWParams: this.$kviCart.uvwParams,
            spreadXYZParams: this.$kviCart.xyzParams,
            storeRegionValues: selectRegions,
            groupsOfProduct: selectGroups,
            categories: selectCategories,
            subcategories: selectSubcategories,
            productSegments: selectSegments,
            newProductLifespanInDays: this.$kviCart.newProductLifespanInDays,
            storeFormat: this.$kviCart.formatSelected,
            tradingId: this.$kviCart.selectMarket.id,
            calculationDepth: +this.$kviCart.calculationDepth,
            correlation: this.$kviCart.correlation ? this.$kviCart.correlation : 0.7,
            highElasticity: this.$kviCart.highElasticity ? this.$kviCart.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.$kviCart.intervalOfUltimateElasticity,
            competitorsPricesParams: this.$kviCart.competitorsPrices,
            kviStrategy: this.$kviCart.kviStrategy.value,
            percentageOfCompetitorsPrice: this.$kviCart.percentageOfCompetitorsPrice,
            marginalProfitability: this.$kviCart.marginalProfitability,
            marginalProfit: this.$kviCart.marginalProfit,
            maxMarginalProfit: this.$kviCart.maxMarginalProfit != null ? this.$kviCart.maxMarginalProfit : 100,
            marginalPriceDifference: this.$kviCart.marginalPriceDifference,
            calculationDay: +this.$kviCart.calculationDay,
            priceCorridor: this.$kviCart.priceCorridor,
            changePriceCorridor: this.$kviCart.changePriceCorridor,
            priceIncreaseLimit: this.$kviCart.priceIncreaseLimit,
            fixLowerBorder: this.$kviCart.fixLowerBorder,
            individualCommonParams: individualConfigsObj,
            depthToPurchasePrice: this.$kviCart.depthToPurchasePrice,
            priceFamilies: this.$kviCart.priceFamilies,
            hardPriceFamilies: this.$kviCart.hardPriceFamilies,
            groupOfProduct: this.$kviCart.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.$kviCart.selectCoefficent.value.enum!,
            byPromoPrices: this.$kviCart.byPromoPrices,
            useCompetitorsPrices: this.$kviCart.useCompetitorsPrices,
            competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
            competitorsCodes: this.$kviCart.competitorsCodes,
            competitorsPriceMethod: this.$kviCart.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.$kviCart.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.$kviCart.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$kviCart.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$kviCart.competitorsMaximumProfit != null ? this.$kviCart.competitorsMaximumProfit : 100,
            competitorsControlParam: this.$kviCart.competitorsControlParam,
            competitorsPriceStrategy: this.$kviCart.competitorsPriceStrategy.value,
            roundKviCompetitorPrice: this.$kviCart.roundKviCompetitorPrice,
            calculateByRegression: !this.$kviCart.calculateByElasticity,
            recalculateCtm: this.$kviCart.recalculateCtm,
            priceChangeLimit: this.$kviCart.priceChangeLimit,
            priceChangeLimitKvi: this.$kviCart.priceChangeLimitKvi,
            priceChangeLimitComp: this.$kviCart.priceChangeLimitComp,
            useBrutForcingParams: false,
            saveAfterOptimize: false,
            optimizationDiff: -1,
            calculatePYR: this.$kviCart.calculatePYR,
            periodPriceIncreaseLimit: this.$kviCart.periodPriceIncreaseLimit,
            period: this.$kviCart.period.value,
            decreaseSalesCount: this.$kviCart.decreaseSalesCount,
            newProductPriceStrategy: this.$kviCart.newProductPriceStrategy.value,
            priceGap: this.$kviCart.priceGap,
            priceGapCtmPc: this.$kviCart.priceGapCtmPc,
            findAutomaticallyPriceSegments: false,
            countPriceSegments: -1,
            promoCalc: false,
            percentageOfRecommendsKviCount: this.$kviCart.percentageOfRecommendsKviCount,
            saveKviSign: this.$kviCart.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.$kviCart.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.$kviCart.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.$kviCart.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$kviCart.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: this.productCodesForAddKvi,
            productCodesForDeleteKvi: this.productCodesForDeleteKvi,
            productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
            productCodesForDeleteCtmPurpose: this.productCodesForAddCtmPurpose,
            roundPricesWithEqualCompStrategy: this.$kviCart.roundPricesWithEqualCompStrategy,
            calculateCompAllowedDeviation: this.$kviCart.calculateCompAllowedDeviation,
            useCompElasticity: this.$kviCart.useCompElasticity,
            minProfitKVI: this.$kviCart.minProfitKVI,
            maxProfitKVI: this.$kviCart.maxProfitKVI != null ? this.$kviCart.maxProfitKVI : 100,
            productRangesAndInternalCodes: this.productRangesArray,
            randomPennies: this.$kviCart.randomPennies,
            manualPennies: this.$kviCart.manualPennies,
            calcWithBatchNumber: true,
            competitorPriceControlParameterPc: this.$kviCart.competitorPriceControlParameterPc,
            thompsonSampling: this.$kviCart.thompsonSampling,
            percentileType: this.$kviCart.percentileType.value,
            revaluationCalculateParams: this.$kviCart.revaluationCalculateParams,
            isFixPricePromo: this.$kviCart.isFixPricePromo,
            spreadByPriceSegments: true,
        };
    }

    private getSkuFilter(): KviCartsSkuFilter {
        const [selectRegions, selectGroups, selectCategories, selectSubcategories, selectSegments] = this.selectData();

        return {
            storeCluster: this.$kviCart.clusterSelected,
            groupsOfProduct: selectGroups,
            categories: selectCategories,
            subcategories: selectSubcategories,
            productSegments: selectSegments,
            seasonValues: [],
            buyerSegments: [],
            storeRegionValues: selectRegions,
            storeFormat: this.$kviCart.formatSelected,
            tradingId: this.$kviCart.selectMarket.id,
            calculationDepth: this.$kviCart.calculationDepth,
            calculationDay: this.$kviCart.calculationDay,
            skuFilter: this.skuFilter,
            groupOfProduct: this.$kviCart.groupOfProduct,
            category: this.$kviCart.categoryOfProduct,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortBySKU,
            kvi: this.selectKVI,
            ctm: this.selectCTM,
            priceSegments: this.selectSegmentPrice,
            needCalculateSku: this.skuListWithCalculating,
            needCalculateSkuLastPricesOnly: false,
            needCalculateSkuActualProfitabilityOnly: false,
            kviRecommendation: this.selectKVIRecommends,
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOne,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwo,
            recipeAttributes: this.selectRecipeAttributes,
            treatmentAttributes: this.selectTreatmentAttributes,
            alwaysCalculateProductSegments: true,
            productRangeFilter: this.selectProductLine,
            groupFilterInSkuList: this.$kviCart.groupOfProduct || this.selectFilterProductGroup,
            categoryFilterInSkuList: this.$kviCart.categoryOfProduct || this.selectFilterProductCategory,
            subcategoryFilterInSkuList: this.$kviCart.subcategory || this.selectFilterProductSubcategory,
            segmentFilterInSkuList: this.$kviCart.segment || this.selectFilterProductSegment,
            competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
            kviCartIdFilter: this.$kviCart.selectKviCart.id,
            sortingField: null,
            isKviCartCompetitorsGrid: false,
        };
    }

    get saveState(): boolean {
        return this.$kviCart.selectKviCart.id === -1 || this.$kviCart.selectMarket.id === -1 || this.calcButtonState();
    }

    get paramsSum(): boolean {
        const u = this.$kviCart.uvwParams.u;
        const v = this.$kviCart.uvwParams.v;
        const w = this.$kviCart.uvwParams.w;
        if (u.toString().length === 0 || v.toString().length === 0 || w.toString().length === 0) {
            return false;
        }
        const sum = (+v + +u + +w);
        return sum === 100;
    }

    get paramsSumXYZ(): boolean {
        const x = this.$kviCart.xyzParams.x;
        const y = this.$kviCart.xyzParams.y;
        const z = this.$kviCart.xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    get calculationDepthValidate(): boolean {
        return this.$kviCart.calculationDepth * 7 >= this.$kviCart.calculationDay;
    }

    get calculationDayValidate(): boolean {
        return this.$kviCart.calculationDay > 0;
    }

    get priceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.$kviCart.priceIncreaseLimit;
        return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;
    }

    get competitorsPricesValidate(): boolean {
        const competitorsP = this.$kviCart.competitorsPrices.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsP);
    }

    get competitorsMinProfitValidate(): boolean {
        const competitorsMinimumProfit = this.$kviCart.competitorsMinimumProfit;
        return competitorsMinimumProfit.toString() !== '' && competitorsMinimumProfit >= -50 && competitorsMinimumProfit <= 500;
    }

    get minProfitKVIValidate(): boolean {
        const minProfitKvi = this.$kviCart.minProfitKVI;
        return minProfitKvi.toString() !== '' && minProfitKvi >= -50 && minProfitKvi <= 500;
    }

    get marginalProfitValidate(): boolean {
        const marginalProfit = this.$kviCart.marginalProfit;
        if (marginalProfit < 0) {
            this.marginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
        } else {
            this.marginalErrorText = ''
        }
        return marginalProfit.toString() !== '' && marginalProfit < 100;
    }

    get priceChangeLimitValidate(): boolean {
        const priceChangeLimit = this.$kviCart.priceChangeLimit;
        return priceChangeLimit.toString() !== '' && priceChangeLimit >= 0 && priceChangeLimit < 100;
    }

    get periodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.$kviCart.periodPriceIncreaseLimit;
        return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
    }

    get highElasticityCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const highElasticity = this.$kviCart.highElasticity.toString();
        this.$log.debug(highElasticity.length > 0, numberPattern.test(highElasticity));
        return numberPattern.test(highElasticity);
    }

    get competitorPriceControlParameterPcValidate(): boolean {
        return this.$kviCart.competitorPriceControlParameterPc.toString() !== '' && this.$kviCart.competitorPriceControlParameterPc > 0 && this.$kviCart.competitorPriceControlParameterPc <= 100;
    }

    get marginalProfitDeclinePcValidate(): boolean {
        const declineProfitabilityPc = this.$kviCart.declineProfitabilityPc;
        return declineProfitabilityPc != null && declineProfitabilityPc < 100;
    }

    get isItemFromListStopped(): boolean {
        return this.itemPageSelected.status === 'STOPPED';
    }

    get isItemFromListActive(): boolean {
        return this.itemPageSelected.status === 'ACTIVE';
    }

    saveIndividualConfigsForSkuPanel() {
        const saveParams = this.getItemsIndividualFilters();

        const products: IModuleItemsProduct[] = [];

        Object.keys(saveParams.individualConfigs as SaleIndividualConfigMap | PromotionIndividualConfigMap).forEach((key: string) => {
            const valuesFromKey = key.split('|||');

            const product: IModuleItemsProduct = {
                internalCode: valuesFromKey[0] ? String(valuesFromKey[0]) : null,
                group: valuesFromKey[1] ? String(valuesFromKey[1]) : null,
                category: valuesFromKey[2] ? String(valuesFromKey[2]) : null,
                storeRegion: valuesFromKey[5] ? String(valuesFromKey[5]) : null,
                storeCluster: valuesFromKey[6] ? String(valuesFromKey[6]) : null,
                subcategory: valuesFromKey[3] ? String(valuesFromKey[3]) : null,
                minPrice: saveParams.individualConfigs && saveParams.individualConfigs[key] && saveParams.individualConfigs[key].minPrice ? Number(saveParams.individualConfigs[key].minPrice) : null, // +-
                maxPrice: saveParams.individualConfigs && saveParams.individualConfigs[key] && saveParams.individualConfigs[key].maxPrice ? Number(saveParams.individualConfigs[key].maxPrice) : null, // +-
                remains: saveParams.individualConfigs && saveParams.individualConfigs[key] && saveParams.individualConfigs[key].remains ? Number(saveParams.individualConfigs[key].remains) : null, // +-
                minMargin: saveParams.individualConfigs && saveParams.individualConfigs[key] && saveParams.individualConfigs[key].minMargin ? Number(saveParams.individualConfigs[key].minMargin) : null, // +-
                purchasePrice: this.moduleType === 'promo' && saveParams.individualConfigs && (saveParams.individualConfigs as PromotionIndividualConfigMap)[key] && (saveParams.individualConfigs as PromotionIndividualConfigMap)[key].purchasePrice != null ? Number((saveParams.individualConfigs as PromotionIndividualConfigMap)[key].purchasePrice) : null,
            }

            if (this.moduleType === 'promo') {
                product.minPromotionDiscount = saveParams.individualConfigs && saveParams.individualConfigs[key] && saveParams.individualConfigs[key].minDiscount ? Number(saveParams.individualConfigs[key].minDiscount) : null;
                product.maxPromotionDiscount = saveParams.individualConfigs && saveParams.individualConfigs[key] && saveParams.individualConfigs[key].maxDiscount ? Number(saveParams.individualConfigs[key].maxDiscount) : null;
            } else {
                product.minSaleDiscount = saveParams.individualConfigs && saveParams.individualConfigs[key] && saveParams.individualConfigs[key].minDiscount ? Number(saveParams.individualConfigs[key].minDiscount) : null;
                product.maxSaleDiscount = saveParams.individualConfigs && saveParams.individualConfigs[key] && saveParams.individualConfigs[key].maxDiscount ? Number(saveParams.individualConfigs[key].maxDiscount) : null;
            }

            products.push(product);
        })

        const data: ModuleItemIndividualConfigFieldsToSave = {
            tradingId: this.moduleData.selectMarket.id,
            groups: this.itemPageSelected.groups.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            categories: this.itemPageSelected.categories.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            subcategories: !!this.itemPageSelected.subcategory ? [this.itemPageSelected.subcategory.id] : [null],
            storeFormat: this.itemPageSelected.format.id,
            storeRegions: this.itemPageSelected.regions.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            storeClusters: this.itemPageSelected.clusters.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            products,
        };

        if (this.moduleType === 'promo') {
            data.promotionId = this.itemPageSelected.id;
        } else {
            data.saleId = this.itemPageSelected.id;
        }

        this.httpSaveModuleItemIndividualConfig(this.moduleType, data)
            .then((r) => {
                this.showInfo(this.$t('shared.productsList.successSaveIndParams') as string);

                this.fetchSkuList();
            })

            .catch((e) => {
                this.showError(this.$t('shared.productsList.errorSaveIndParams') as string);
            });
    }

    getItemsIndividualFilters(): IndividualConfigCmd<SaleIndividualConfigMap | PromotionIndividualConfigMap> {
        const saveParams = new IndividualConfigCmd<SaleIndividualConfigMap | PromotionIndividualConfigMap>();
        saveParams.tradingId = this.moduleData.selectMarket.id;

        const individualConfigsObj: any = {};
// tslint:disable-next-line: forin
        for (const key in this.moduleData.individualConfig) {
            const value = this.moduleData.individualConfig[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = value;
            }
        }

        saveParams.individualConfigs = individualConfigsObj;

        return saveParams;
    }

    getCommonIndividualFilters(): IndividualConfigCmd<CalcIndividualConfigMap> {
        const saveCommonParams = new IndividualConfigCmd<CalcIndividualConfigMap>();
        saveCommonParams.tradingId = this.moduleData.selectMarket.id;

        const individualConfigsObj: any = {};
// tslint:disable-next-line: forin
        for (const key in this.moduleData.individualCommonParams) {
            const value = this.moduleData.individualCommonParams[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = value;
            }
        }

        saveCommonParams.individualConfigs = individualConfigsObj;
        saveCommonParams.productRangesAndInternalCodes = this.productRangesArray;

        return saveCommonParams;
    }

    getUniqueProductKey(product: any): string {
        const SEP = '|||';

        return [
            product.internalCode,
            product.group && product.group.name,
            product.category && product.category.name,
            (product.subcategory && product.subcategory.name) || '',
            product.storeFormat && product.storeFormat.id,
            (product.storeRegion && product.storeRegion.name) || '',
            (product.storeCluster && product.storeCluster.name) || '',
        ].join(SEP);
    }

    getIndividFieldValue(individualConfig: ConfigMap<SaleIndividualConfig | PromotionIndividualConfig>, record: any, property: keyof (SaleIndividualConfig | PromotionIndividualConfig), serverValue: string | number) {
        const localValue = this.getModuleItemIndividConfig(individualConfig, this.getUniqueProductKey(record), property);

        return localValue || localValue === '' ? localValue : serverValue;
    }

    handleFromNumberToNumberInputFocusOut(fromNumber: number, toNumber: number, config: any, record: any, property: keyof (SaleIndividualConfig | PromotionIndividualConfig), value: string | number) {
        const propertyValue = this.getIndividFieldValue(config, record, property, value);

        if (typeof propertyValue === 'string') {
            if (propertyValue === '-') {
                this.setModuleItemIndividConfig(config, this.getUniqueProductKey(record), property, '');
                this.saveModuleItems();
            } else if (propertyValue === '-0') {
                this.setModuleItemIndividConfig(config, this.getUniqueProductKey(record), property, 0);
                this.saveModuleItems();
            } else {
                const inputValue = isNaN(parseFloat(propertyValue)) ? 0 : parseFloat(propertyValue);

                const valueToSetInConfig: number = (() => {
                    if (inputValue > toNumber) {
                        return toNumber;
                    } else if (inputValue < fromNumber) {
                        return fromNumber;
                    } else {
                        return inputValue;
                    }
                })();

                if (inputValue !== valueToSetInConfig) {
                    this.setModuleItemIndividConfig(config, this.getUniqueProductKey(record), property, valueToSetInConfig);
                    this.saveModuleItems();
                }
            }
        }
    }

    valueInRange(input: string, fromNumber: number, toNumber: number): number {
        const inputValue = isNaN(parseFloat(input)) ? 0 : parseFloat(input);

        if (inputValue > toNumber) {
            return toNumber;
        } else if (inputValue < fromNumber) {
            return fromNumber;
        } else {
            return inputValue;
        }
    }

    handleMaxSaleDiscountValueChanged(record: any) {
        const productMinDiscount = this.getIndividFieldValue(this.moduleData.individualConfig, record, 'minDiscount', record.minSaleDiscount)
        const productMaxDiscount = this.getIndividFieldValue(this.moduleData.individualConfig, record, 'maxDiscount', record.maxSaleDiscount)

        if ((productMinDiscount || productMinDiscount === 0) && (productMaxDiscount || productMaxDiscount === 0) && isNumber(productMinDiscount) && isNumber(productMaxDiscount)
            && productMaxDiscount < productMinDiscount) {
            this.setModuleItemIndividConfig(
                this.moduleData.individualConfig,
                this.getUniqueProductKey(record),
                'minDiscount',
                productMaxDiscount,
            );

            this.saveModuleItems();
        }
    }

    handleMaxPromotionDiscountValueChanged(record: any) {
        const productMinDiscount = this.getIndividFieldValue(this.moduleData.individualConfig, record, 'minDiscount', record.minPromotionDiscount)
        const productMaxDiscount = this.getIndividFieldValue(this.moduleData.individualConfig, record, 'maxDiscount', record.maxPromotionDiscount)

        if ((productMinDiscount || productMinDiscount === 0) && (productMaxDiscount || productMaxDiscount === 0) && isNumber(productMinDiscount) && isNumber(productMaxDiscount)
            && productMaxDiscount < productMinDiscount) {
            this.setModuleItemIndividConfig(
                this.moduleData.individualConfig,
                this.getUniqueProductKey(record),
                'minDiscount',
                productMaxDiscount,
            );

            this.saveModuleItems();
        }
    }
}
